import makeWidgetFor from "../../viewModels/makeWidgetFor";
import { registerWidget } from "../widget";
import InitializationWithOutagesService from "services/initialization/initializationWithOutagesService";
import RefundRequestNoticeViewModel from "../../viewModels/notice/refundRequest/refundRequestNoticeViewModel";

const RefundRequestWidgetIdentifier = "edaz-refund-request";

registerWidget({
  component: makeWidgetFor(RefundRequestWidgetIdentifier, [RefundRequestNoticeViewModel], InitializationWithOutagesService),
  configuration: {
    tagname: RefundRequestWidgetIdentifier,
  },
});
